import { useState } from "react";

function Navigation({
  planets,
  currentPlanet,
  currentPlanetObject,
  setCurrentPlanet,
}) {
  const [mobileMenu, setMobileMenu] = useState(false);

  function handleMobileMenu() {
    setMobileMenu((prevState) => !prevState);
  }
  return (
    <nav className="navigation">
      <div className="heading-box">
        <h1 className="main-heading">The planets</h1>
        <button className="button-hamburger" onClick={handleMobileMenu}>
          <img
            className="icon-hamburger"
            src="./assets/icon-hamburger.svg"
            alt="icon hamburger"
          />
        </button>
      </div>
      <ul className={`list-of-planets ${mobileMenu ? "mobile-menu" : ""}`}>
        <li
          className={`${currentPlanet === 0 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 0
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(0)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[0].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Mercury</span>
            ) : (
              <span className="show-for-desktop-tablet">Mercury</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
        <li
          className={`${currentPlanet === 1 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 1
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(1)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[1].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Venus</span>
            ) : (
              <span className="show-for-desktop-tablet">Venus</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
        <li
          className={`${currentPlanet === 2 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 2
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(2)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[2].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Earth</span>
            ) : (
              <span className="show-for-desktop-tablet">Earth</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
        <li
          className={`${currentPlanet === 3 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 3
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(3)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[3].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Mars</span>
            ) : (
              <span className="show-for-desktop-tablet">Mars</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
        <li
          className={`${currentPlanet === 4 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 4
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(4)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[4].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Jupiter</span>
            ) : (
              <span className="show-for-desktop-tablet">Jupiter</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
        <li
          className={`${currentPlanet === 5 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 5
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(5)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[5].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Saturn</span>
            ) : (
              <span className="show-for-desktop-tablet">Saturn</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
        <li
          className={`${currentPlanet === 6 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 6
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(6)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[6].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Uranus</span>
            ) : (
              <span className="show-for-desktop-tablet">Uranus</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
        <li
          className={`${currentPlanet === 7 && "nav-li-active on-click"}`}
          style={{
            borderTop:
              currentPlanet === 7
                ? `4px solid ${currentPlanetObject.color}`
                : "",
          }}
          onClick={() => setCurrentPlanet(7)}
        >
          <div className="planet-circle-box">
            {mobileMenu && (
              <div
                className="planet-circle"
                style={{
                  backgroundColor: mobileMenu ? `${planets[7].color}` : "",
                }}
              ></div>
            )}
            {mobileMenu ? (
              <span>Neptune</span>
            ) : (
              <span className="show-for-desktop-tablet">Neptune</span>
            )}
          </div>

          {mobileMenu && (
            <img src="./assets/icon-chevron.svg" alt="icon-chevron" />
          )}
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
